import React, { useEffect, useRef } from "react";
import "../styles.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import UrbanDesktop from "./urbanDesktop";
import Confidence from "./confidence/confidence";
import Creativity from "./creativity/creativity";
import Everyday from "./everyday/everyday";
import Beyond from "./beyond/beyond";

export default function Urban() {
  return (
    <>
      <UrbanDesktop />
      <Confidence />
      <Creativity />
      <Everyday />
      <Beyond />
    </>
  );
}
